export const getNotificationCountString = (notificationCount?: number) => {
  if (notificationCount !== undefined) {
    return notificationCount > 9 ? '9+' : notificationCount.toString()
  } else {
    return '-'
  }
}
